import i18n from 'i18next'
import {Settings} from 'luxon'
import {setDefaultLocale as setReactDatePickerDefaultLocale} from 'react-datepicker'
import {initReactI18next} from 'react-i18next'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require('./locales/en.json'),
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    format: (value, format) => {
      switch (format) {
        case 'formatIssueIndex':
          const intValue = parseInt(value)
          if (isNaN(intValue)) return ''
          return `${intValue}`.padStart(2, '0')
        case 'currency': {
          const amount = value?.amount ?? 0
          const currency = value?.currency ?? 'EUR'
          return Intl.NumberFormat(navigator.language, {
            style: 'currency',
            currency,
          }).format(amount)
        }
      }

      return value
    },
  },
})

Settings.defaultLocale = 'en-US'
setReactDatePickerDefaultLocale('en-US')

export default i18n
